import type {
  AlgoliaEventItem,
  CategoryItem,
} from '~/composables/types/algolia'

/**
 * Normalize Algolia hit `categories` into a flat array of { name, slug }.
 */
export const categoriesFromAlgoliaHit = (
  hit: Pick<AlgoliaEventItem, 'categories'>
): CategoryItem[] => {
  const raw = hit.categories
  if (!raw) return []
  if (Array.isArray(raw)) return raw
  return (raw as { data?: CategoryItem[] }).data ?? []
}

/**
 * Build a display-name → slug map from event-list search hits so transactional
 * navigation can resolve Strapi `categorySlug` from filter display names.
 */
export const buildCategoryNameToSlugMapFromAlgoliaHits = (
  hits: Pick<AlgoliaEventItem, 'categories'>[]
): Record<string, string> => {
  const map: Record<string, string> = {}
  for (const hit of hits) {
    for (const cat of categoriesFromAlgoliaHit(hit)) {
      if (cat.name && cat.slug) map[cat.name] = cat.slug
    }
  }
  return map
}
